import http from "../../services/httpService";
import { injectHtml } from "../../utils/htmlUtil";
import { openDialog, dialogModel } from "../common/dialog";
import { error, isEmpty, initToggleIconRotate, rotateElement } from "../common/global";
import { catchError } from "../../utils/errorUtil";

const props = {
    homePageMarker: '#m-home-page',
    swiperCarouselClass: '.homepage-carousel'

};

export function initHomePage() {

    if ($(props.homePageMarker).length) {

        initHeaderCarousel();
    }

}

//START - PRODUCT PAGE - CORE
async function initHeaderCarousel() {

    var mySwiper = new Swiper(props.swiperCarouselClass, {
        speed: 1500,
        spaceBetween: 100,
        loop: true,
        effect: 'fade',
        // Disabled autoplay while working on carousel
        autoplay: { 
            delay: 5000,
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: '.carousel-button-next',
            prevEl: '.carousel-button-prev',
        }
    });
}
